import { overrideGammaDimensions } from 'modules/shift_management/store/internal/models/View'
type GammaDimension = keyof ReturnType<typeof overrideGammaDimensions>

export const resolveDimension = (dimension: GammaDimension, fallback: number) => {
  const value = overrideGammaDimensions()[dimension]
  if (!value) return fallback
  return Number.parseInt(value.replace('px', ''), 10)
}
